module.exports = __webpack_public_path__ + "img/backward.b8b835e5.svg";